"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get HANDLE_WEBHOOK () {
        return HANDLE_WEBHOOK;
    },
    get HookHandlerService () {
        return HookHandlerService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _webhookHelpers = require("~/helpers/webhookHelpers");
const _Jobs = require("~/interface/Jobs");
const _Mail = require("~/interface/Mail");
const _models = require("~/models");
const _eventemitterinterface = require("~/modules/event-emitter/event-emitter.interface");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _mailservice = require("~/services/mail/mail.service");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
const HANDLE_WEBHOOK = '__nc_handleHooks';
let HookHandlerService = class HookHandlerService {
    async handleViewHooks(_context, _param) {}
    async handleHooks(context, param) {
        const { hookName, prevData, newData, user, viewId, modelId } = param;
        const [event, operation] = hookName.split('.');
        const view = await _models.View.get(context, viewId);
        const model = await _models.Model.get(context, modelId);
        // handle form view data submission
        if (// [DEPRECATED]: v2 support for bulkInsert
        (hookName === 'after.insert' || hookName === 'after.bulkInsert') && view && view.type === _nocodbsdk.ViewTypes.FORM) {
            try {
                const formView = await view.getView(context);
                const emails = Object.entries(JSON.parse(formView == null ? void 0 : formView.email) || {}).filter((a)=>a[1]).map((a)=>a[0]);
                if (emails == null ? void 0 : emails.length) {
                    const { columns } = await _models.FormView.getWithInfo(context, formView.fk_view_id);
                    const allColumns = await model.getColumns(context);
                    const fieldById = columns.reduce((o, f)=>{
                        return Object.assign(o, {
                            [f.fk_column_id]: f
                        });
                    }, {});
                    let order = 1;
                    const filteredColumns = allColumns == null ? void 0 : allColumns.map((c)=>{
                        return _extends({}, c, {
                            fk_column_id: c.id,
                            fk_view_id: formView.fk_view_id
                        }, fieldById[c.id] ? fieldById[c.id] : {}, {
                            order: fieldById[c.id] && fieldById[c.id].order || order++,
                            id: fieldById[c.id] && fieldById[c.id].id
                        });
                    }).sort((a, b)=>a.order - b.order).filter((f)=>f.show && f.uidt !== _nocodbsdk.UITypes.Rollup && f.uidt !== _nocodbsdk.UITypes.Lookup && f.uidt !== _nocodbsdk.UITypes.Formula && f.uidt !== _nocodbsdk.UITypes.QrCode && f.uidt !== _nocodbsdk.UITypes.Barcode && f.uidt !== _nocodbsdk.UITypes.SpecificDBType && f.uidt !== _nocodbsdk.UITypes.Button).sort((a, b)=>a.order - b.order).map((c)=>{
                        c.required = !!(c.required || 0);
                        return c;
                    });
                    const source = await _models.Source.get(context, model.source_id);
                    const models = await source.getModels(context);
                    const metas = models.reduce((o, m)=>{
                        return Object.assign(o, {
                            [m.id]: m
                        });
                    }, {});
                    const formattedData = (0, _webhookHelpers.transformDataForMailRendering)(newData, filteredColumns, source, model, metas);
                    formView.title = view.title;
                    const base = await _models.Base.get(context, model.base_id);
                    await this.mailService.sendMail({
                        mailEvent: _Mail.MailEvent.FORM_SUBMISSION,
                        payload: {
                            formView: formView,
                            base,
                            emails,
                            model,
                            data: formattedData
                        }
                    });
                }
            } catch (e) {
                this.logger.error({
                    error: e,
                    details: 'Error while sending form submission email',
                    hookName
                });
            }
        }
        const hooks = await _models.Hook.list(context, {
            fk_model_id: modelId,
            event: event,
            operation: operation,
            affectedColumns: await (0, _webhookHelpers.getAffectedColumns)(context, {
                hookName,
                newData,
                prevData,
                model
            })
        });
        for (const hook of hooks){
            if (hook.active) {
                try {
                    await this.jobsService.add(_Jobs.JobTypes.HandleWebhook, {
                        context,
                        hookId: hook.id,
                        modelId,
                        viewId,
                        prevData,
                        newData,
                        user,
                        hookName,
                        ncSiteUrl: context.nc_site_url
                    });
                } catch (e) {
                    this.logger.error({
                        error: e,
                        details: 'Error while invoking webhook',
                        hook: hook.id
                    });
                }
            }
        }
    }
    onModuleInit() {
        this.unsubscribe = this.eventEmitter.on(HANDLE_WEBHOOK, async (arg)=>{
            try {
                const { context } = arg, rest = _object_without_properties_loose(arg, [
                    "context"
                ]);
                return this.handleHooks(_extends({}, context, {
                    cache: false,
                    cacheMap: undefined
                }), rest);
            } catch (e) {
                this.logger.error({
                    error: e,
                    details: 'Error while handle webook on HookHandlerService'
                });
            }
        });
    }
    onModuleDestroy() {
        this.unsubscribe == null ? void 0 : this.unsubscribe.call(this);
    }
    constructor(eventEmitter, jobsService, mailService){
        this.eventEmitter = eventEmitter;
        this.jobsService = jobsService;
        this.mailService = mailService;
        this.logger = new _common.Logger(HookHandlerService.name);
    }
};
HookHandlerService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _common.Inject)('IEventEmitter')),
    _ts_param(1, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _eventemitterinterface.IEventEmitter === "undefined" ? Object : _eventemitterinterface.IEventEmitter,
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService,
        typeof _mailservice.MailService === "undefined" ? Object : _mailservice.MailService
    ])
], HookHandlerService);
